var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$userInfo.isSupportUser || _vm.$userInfo.isCustomerAdministrator
      ? _c("div", { staticClass: "tile is-parent pl-1" }, [
          _c(
            "article",
            { staticClass: "tile is-child box" },
            [
              _c(
                "div",
                { staticClass: "columns is-flex is-align-items-center" },
                [
                  _vm._m(0),
                  !_vm.hasError &&
                  _vm.showSavingStatus &&
                  !_vm.toastNotificationEnabled
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "column is-flex is-justify-content-flex-end is-align-items-center",
                        },
                        [
                          _vm.saving
                            ? _c("span", {
                                staticClass: "button is-loading is-white",
                                staticStyle: { height: "27px" },
                              })
                            : _c(
                                "span",
                                { staticClass: "text has-text-success" },
                                [
                                  _c("span", { staticClass: "mso mso-18px" }, [
                                    _vm._v("check_circle"),
                                  ]),
                                ]
                              ),
                          _c(
                            "span",
                            {
                              staticClass: "is-size-6",
                              class: _vm.saving
                                ? "has-text-warning"
                                : "has-text-success",
                            },
                            [_vm._v(_vm._s(_vm.savingStatus))]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _c("div", { staticClass: "columns is-multiline" }, [
                _c("div", { staticClass: "column is-half" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Display Name"),
                  ]),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.companySetting.eSetDisplayName,
                          expression: "companySetting.eSetDisplayName",
                        },
                      ],
                      staticClass: "input",
                      attrs: { type: "text", placeholder: "Company Name" },
                      domProps: { value: _vm.companySetting.eSetDisplayName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.companySetting,
                            "eSetDisplayName",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm.$v.companySetting.eSetDisplayName.$dirty &&
                    !_vm.$v.companySetting.eSetDisplayName.required
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v("Name Required "),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c("div", { staticClass: "column is-half" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Display Email"),
                  ]),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.companySetting.eSetEmail,
                          expression: "companySetting.eSetEmail",
                        },
                      ],
                      staticClass: "input",
                      attrs: { type: "text", placeholder: "Company Email" },
                      domProps: { value: _vm.companySetting.eSetEmail },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.companySetting,
                            "eSetEmail",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm.$v.companySetting.eSetEmail.$dirty &&
                    !_vm.$v.companySetting.eSetEmail.required
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v("Email Required "),
                        ])
                      : _vm._e(),
                    !_vm.$v.companySetting.eSetEmail.email
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v("Please enter a valid email "),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c("div", { staticClass: "column is-half" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Enabled Auto CC"),
                  ]),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "pretty p-icon p-curve p-smooth m-0 p-bigger",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.companySetting.enabledAutoCC,
                              expression: "companySetting.enabledAutoCC",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(
                              _vm.companySetting.enabledAutoCC
                            )
                              ? _vm._i(_vm.companySetting.enabledAutoCC, null) >
                                -1
                              : _vm.companySetting.enabledAutoCC,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.companySetting.enabledAutoCC,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.companySetting,
                                      "enabledAutoCC",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.companySetting,
                                      "enabledAutoCC",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(
                                  _vm.companySetting,
                                  "enabledAutoCC",
                                  $$c
                                )
                              }
                            },
                          },
                        }),
                        _vm._m(1),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label mb-3" }, [
                  _vm._v("Company Signature Image"),
                ]),
                _vm.emailSignatureImage
                  ? _c(
                      "div",
                      { staticClass: "is-flex is-align-items-center" },
                      [
                        _c("img", {
                          staticClass: "emailSignature mr-5",
                          attrs: {
                            src: _vm.emailSignatureImage,
                            alt: "Company Email Signature Image",
                          },
                        }),
                        _c(
                          "button",
                          {
                            staticClass: "button has-text-danger",
                            attrs: { title: "Delete" },
                            on: { click: _vm.removeImage },
                          },
                          [
                            _c("span", { staticClass: "mso mso-24px" }, [
                              _vm._v("remove"),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _c(
                      "div",
                      [
                        _c("vue-dropzone", {
                          ref: "emailSignatureDropzone",
                          attrs: {
                            id: "emailSignatureDropzone",
                            options: _vm.dropzoneOptions,
                          },
                          on: {
                            "vdropzone-mounted": _vm.dropzoneMounted,
                            "vdropzone-success": _vm.dropzoneSuccess,
                            "vdropzone-error": _vm.dropzoneError,
                          },
                        }),
                        _c("p", { staticClass: "text is-size-7 is-italic" }, [
                          _vm._v(
                            "Note: Maximum image file size is 100KB. One file only."
                          ),
                        ]),
                      ],
                      1
                    ),
              ]),
              _vm.emailSignatureImage
                ? _c(
                    "confirm-modal",
                    {
                      attrs: {
                        active: _vm.isConfirmModalActive,
                        "ok-text": "Yes",
                        "cancel-text": "No",
                      },
                      on: {
                        "update:active": function ($event) {
                          _vm.isConfirmModalActive = $event
                        },
                        ok: function ($event) {
                          return _vm.deleteImage(true)
                        },
                        cancel: function ($event) {
                          return _vm.deleteImage(false)
                        },
                      },
                    },
                    [
                      _c(
                        "p",
                        { attrs: { slot: "text-title" }, slot: "text-title" },
                        [_vm._v("Delete Company Signature Image")]
                      ),
                      _c(
                        "p",
                        {
                          attrs: { slot: "text-content" },
                          slot: "text-content",
                        },
                        [
                          _vm._v(
                            " Company Signature Image will be deleted. Continue? "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ])
      : _c("div", { staticClass: "is-flex is-justify-content-center pt-5" }, [
          _c(
            "div",
            {
              staticClass:
                "notification is-danger is-flex is-justify-content-center is-size-4",
              staticStyle: { width: "50%" },
            },
            [_vm._v(" You do not have permissions on this page ")]
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Two-Way Emails")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("span", { staticClass: "icon mso mso-24px" }, [_vm._v("check")]),
      _c("label"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }